import React from 'react';
import AppNav from './AppNav';
import { parseRole, roleLabel } from '../utils/roles';

function AppHeader({
  user,
  pageTitle,
  subtitle,
  children,
  onNavigate,
  onLogout,
  active,
  navLinks,
}) {
  return (
    <header className="app-header">
      <div className="app-header-top">
        <div className="app-brand">
          <p className="app-brand-location">{user?.location || 'What You Asked For CRM'}</p>
          {pageTitle && <h1 className="app-page-title">{pageTitle}</h1>}
          {subtitle && <p className="app-page-subtitle">{subtitle}</p>}
          {(user?.name || children) && (
            <div className="app-user-meta">
              {user?.name && (
                <span>
                  {user.name}
                  {user?.department ? ` · ${user.department}` : ''}
                  {` · ${roleLabel(parseRole(user))}`}
                </span>
              )}
              {children}
            </div>
          )}
        </div>
      </div>

      {onNavigate && onLogout ? (
        <AppNav
          user={user}
          onNavigate={onNavigate}
          onLogout={onLogout}
          active={active}
        />
      ) : (
        <div className="nav-links legacy-nav-links">{navLinks}</div>
      )}
    </header>
  );
}

export default AppHeader;
